/**
 constants
 Created by RuSsCiTy on 07.05.2018
 **/

/** DEVELOPER CONSTANTS */
export const DEVELOP_MODE = false;
export const SIMULATE_NETWORK_DELAY_IN_MS = 300;

export const BROWSER = {
  SUPPORTED_VERSION_MIN: {
    FIREFOX: 30,
    CHROME: 31
  },
  CHROME: "CHROME",
  FIREFOX: "FIREFOX",
  SAFARI: "SAFARI",
  IE: "IE",
  EDGE: "EDGE"
};

export const OS = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  MAC: "MAC",
  WIN: "WIN"
};

/**
 * Constant for page selecting
 * @type {{loading: string, login: string, register: string, pwrecovery: string}}
 */
export const PAGES = {
  intro: "intro",
  accept_cookie: "accept_cookie",
  details: "details",
  bottom_info: "bottom_info"
};

/**
 * Constant to represent user state
 * @type {{logged_in: string, not_logged_in: string}}
 */
export const USER_STATE = {
  logged_in_new: "logged_in_new",
  logged_in_exist: "logged_in_exist",
  not_logged_in: "not_logged_in"
};
/**
 *
 * @type {{}}
 */
export const COMPANY_ROLE = {
  COMPANY_EXECUTIVE: "COMPANY_EXECUTIVE",
  COMPANY_VIEWER: "COMPANY_VIEWER",
  COMPANY_ADMIN: "COMPANY_ADMIN",
  COMPANY_MANAGER: "COMPANY_MANAGER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  COMPANY_MEMBER: "COMPANY_MEMBER"
};

/**
 * Constant to represent server code answers
 * @type {{CODE_USER_EMAIL_UNKNOWN: string, CODE_USER_CREDENTIALS_INCORRECT: string, OAUTH_SUCCESS_USER_NEW: string, OAUTH_SUCCESS_USER_EXIST: string, OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER: string}}
 */
export const SERVER_CONST = {
  CODE_USER_EMAIL_UNKNOWN: "userEmailUnknown",
  CODE_USER_CREDENTIALS_INCORRECT: "userCredentialsIncorrect",
  CODE_USER_EMAIL_NOT_VERIFIED: "userEmailNotVerified",

  // OAUTH
  OAUTH_SUCCESS_USER_NEW: "OAUTH_SUCCESS_USER_NEW",
  OAUTH_SUCCESS_USER_EXIST: "OAUTH_SUCCESS_USER_EXIST",
  OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER:
    "OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER"
};

/**
 * Constant to represent actual native app versions
 * @type {{ANDROID_VER: string, IOS_VER: string}}
 */
export const APP_VERSIONS = {
  ANDROID_VER: "1.5.9",
  IOS_VER: "1.5.6"
};

export const APP_TYPES = {
  andr: "andr",
  ios: "ios",
  web: "web"
};

/** REGEX */
export const EMAIL_REG_EX = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let prefix = "";

export const COOKIE_PREFERENCES = {
  COOKIE_ACCEPTED: "COOKIE_ACCEPTED",
  COOKIE_SETTINGS: "COOKIE_SETTINGS"
};

export const OPTOUT_URLS = {
  SALESFORCE: "https://consumer.krxd.net/consumer/optout?verify=true"
};
export const OPTIN_URLS = {
  SALESFORCE: "https://consumer.krxd.net/consumer/optin?verify=true"
};

export const ANALYTICS_IDS = [
  "UA-48533890-1", // movemygps web
  "UA-48533890-2", // alltracker web
  "UA-48533890-3" // russ.city web
];

export const URL_TO_COOKIE_PRIVACY = "https://alltracker.org/cookies";



// WEBPACK FOOTER //
// ./src-cookie-manager/const/constants.js